import searchIcon from "@/img/search-icon-latest.svg";
import CityLocation from "@/components/city-location/CityLocation";
import SearchModal from "@/components/search-modal/SearchModal";

import { useMemo, useState } from "@wordpress/element";
import { useDispatch, useSelect } from "@wordpress/data";
import { WeatherDispatch, WeatherSelect } from "@/store/type";
import { WEATHER_STORE } from "@/store/store";
import { CityFeature } from "@/schemas/city-schema";
import { LocationType } from "@/types/location-params-type";
import { getCurrentLanguage } from "@/helpers/get-current-langage";
import { useTranslation } from "react-i18next";

import "./style.scss";

export const App = () => {
	const lang = getCurrentLanguage();
	const isArabic = lang === "ar";
	const { t } = useTranslation();
	const { setWorldLocation } = useDispatch(WEATHER_STORE) as WeatherDispatch;

	const [inputValue, setInputValue] = useState<string>("");
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const { name, cityData } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
			const store = select(WEATHER_STORE);

			return {
				...store.getWorldLocationState(),
				...store.getWorldCitiesState(),
			};
		},
	);

	const citiesResult: CityFeature[] = useMemo(() => {
		return cityData
			.filter((item) =>
				isArabic
					? item.properties.ar_label
					: item.properties.en_label

							.toLowerCase()
							.trim()
							.startsWith(inputValue.toLowerCase().trim()),
			)
			.map((item) => {
				return {
					...item,
					properties: {
						...item.properties,
						label: item.properties.en_label,
						id: String(item.properties.id_area),
						name_ar: item.properties.ar_label,
						name_en: item.properties.en_label,
					},
				};
			});
	}, [cityData, inputValue]);

	const handleSelectLocation = (location: Pick<CityFeature, "properties">) => {
		const {
			properties: { id, label },
		} = location;

		setWorldLocation({
			id,
			name: label,
		});
		setInputValue(label);
		setIsOpen(false);
	};

	const locationJsx = name.trim().length > 0 ? ` ${name}` : t("worldForecast");

	return (
		<div className="world-search-bar">
			<div className="wrapper">
				<CityLocation locationName={locationJsx} showCity={true} />

				<img
					className="search-bar-img"
					onClick={() => {
						setIsOpen(true);
						setInputValue("");
					}}
					src={searchIcon}
					alt="search icon"
				/>

				<SearchModal
					handleSelectLocation={(value: Pick<CityFeature, "properties">) =>
						handleSelectLocation(value)
					}
					placeholder={t("searchWorldStation")}
					showFav={false}
					locationType={LocationType.WORLD_FORECAST}
					isOpen={isOpen}
					cities={citiesResult}
					userPosition={null}
					closeModal={() => setIsOpen(false)}
				/>
			</div>
		</div>
	);
};

export default App;
